// @ts-nocheck
import type { ValidationIssue } from '../../diagnostics';

/** Single entry from the arbitraryFieldsList persistence format. */
export interface ArbitraryFieldEntry {
  categoryId: string;
  propertyId: string;
  value: string;
}

/** Result of a category property read operation. */
export interface CategoryPropertyReadResult {
  /** True if an entry existed in arbitraryFieldsList (even if coercion failed). */
  found: boolean;
  /** The raw string from storage, if found. */
  rawValue?: string;
  /** The typed runtime value after coercion. undefined if not found and no default. */
  typedValue?: unknown;
  /** True when the default value from PropertyDefinition was used. */
  usedDefault: boolean;
  /** Any coercion issues (warnings or errors). */
  issues: ValidationIssue[];
}

/** Result of a category property write operation. */
export interface CategoryPropertyWriteResult {
  /** True when the write succeeded without blocking errors. */
  success: boolean;
  /** The string value that was stored or would be stored. */
  storedRawValue?: string;
  /** True when the write resulted in removing the entry (unset/empty write). */
  removedEntry: boolean;
  /** Updated arbitraryFieldsList (immutable — does not mutate input). */
  updatedFields: ArbitraryFieldEntry[];
  /** Any coercion/validation issues. */
  issues: ValidationIssue[];
}

/** Controls coercion behavior for read/write. */
export interface CoercionPolicy {
  /** When true, attempt to parse numeric strings into numbers on read. Default: true */
  allowStringToNumber?: boolean;
  /** When true, accept "true"/"false"/"1"/"0"/"yes"/"no" as booleans on read. Default: true */
  allowStringToBoolean?: boolean;
  /** When true, trim whitespace from text inputs on write. Default: true */
  trimTextOnWrite?: boolean;
  /** When true, reject unknown enum values (produce error). Default: false (produce warning) */
  strictEnumValues?: boolean;
}

export const DEFAULT_COERCION_POLICY: CoercionPolicy = {
  allowStringToNumber: true,
  allowStringToBoolean: true,
  trimTextOnWrite: true,
  strictEnumValues: false,
};
